<div class="auth0-lock-input-block auth0-lock-input-wrap">
  <input 
    [type]="showPassword ? 'text' : 'password'" 
    [value]="value" 
    (input)="onInputChange($event.target.value)"
    [disabled]="disabled"
    class="auth0-lock-input"
    autocomplete="on"
    autocapitalize="off"
    [attr.aria-label]="placeholder"
    [placeholder]="placeholder"
    maxlength="45">
  <button
    type="button"
    mat-icon-button
    class="password-toggle"
    [matTooltip]="showPassword ? 'Hide password' : 'Show password'"
    #tt="matTooltip"
    [matTooltipShowDelay]="0"
    [matTooltipHideDelay]="150"
    (mouseenter)="tt.show(0)"
    (mouseleave)="tt.hide(0)"
    (mousedown)="onMouseDown($event, tt)"
    matTooltipPosition="above"
  >
    <mat-icon>{{ showPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
  </button>
</div>